import { supabase } from './supabaseClient';

export interface CheckoutSessionRequest {
  price_id: string;
  success_url: string;
  cancel_url: string;
  mode: 'payment' | 'subscription';
}

export interface BookingCheckoutSessionRequest {
  price_id: string;
  success_url: string;
  cancel_url: string;
  mode: 'payment' | 'subscription';
  customer_email: string;
  customer_name: string;
  customer_phone: string;
  appointment_date: string;
  appointment_time: string;
  customer_notes?: string;
  location: string;
}

export interface CheckoutSessionResponse {
  sessionId: string;
  url: string;
  appointmentId?: string;
}

export async function createCheckoutSession(request: CheckoutSessionRequest): Promise<CheckoutSessionResponse> {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session) {
    throw new Error('User must be authenticated to create checkout session');
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  
  const response = await fetch(`${supabaseUrl}/functions/v1/stripe-checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
      'apikey': supabaseAnonKey
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to create checkout session');
  }

  return response.json();
}

export async function createBookingCheckoutSession(request: BookingCheckoutSessionRequest): Promise<CheckoutSessionResponse> {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase configuration. Please check your environment variables.');
  }

  const functionUrl = `${supabaseUrl}/functions/v1/create-booking-checkout`;
  
  console.log('Calling edge function:', functionUrl);
  console.log('Request payload:', request);
  
  const response = await fetch(`${supabaseUrl}/functions/v1/create-booking-checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${supabaseAnonKey}`,
      'apikey': supabaseAnonKey
    },
    body: JSON.stringify(request),
  });

  console.log('Response status:', response.status);
  console.log('Response ok:', response.ok);

  if (!response.ok) {
    const responseText = await response.text();
    console.error('Error response:', responseText);
    
    let errorMessage = 'Failed to create booking checkout session';
    try {
      const errorData = JSON.parse(responseText);
      errorMessage = errorData.error || errorData.message || errorMessage;
    } catch (parseError) {
      errorMessage = `HTTP ${response.status}: ${responseText || 'Unknown error'}`;
    }
    throw new Error(errorMessage);
  }

  return response.json();
}

export function getProductByPriceId(priceId: string) {
  const { products } = require('../stripe-config');
  return products.find((product: any) => product.priceId === priceId);
}